import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function BulletIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 16V16C10.5668 16 9 14.4332 9 12.5V12.5C9 10.5668 10.5668 9 12.5 9V9C14.4332 9 16 10.5668 16 12.5V12.5C16 14.4332 14.4332 16 12.5 16Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
